export const USER_SIGN_IN_REQUEST = "USER_SIGNIN_REQUEST"
export const USER_SIGN_IN_SUCCESS = "USER_SIGNIN_SUCCESS"
export const USER_SIGN_IN_FAIL = "USER_SIGNIN_FAIL"
export const USER_SIGN_OUT = "USER_SIGNIN_OUT"

export const USER_REGISTRATION_REQUEST = "USER_REGISTRATION_REQUEST"
export const USER_REGISTRATION_SUCCESS = "USER_REGISTRATION_SUCCESS"
export const USER_REGISTRATION_FAIL = "USER_REGISTRATION_FAIL"

export const USER_MESSAGE = 'USER_MESSAGE'

export const ORDER_MINE_REQUEST = "ORDER_MINE_REQUEST"
export const ORDER_MINE_SUCCESS = "ORDER_MINE_SUCCESS"
export const ORDER_MINE_FAIL = "ORDER_MINE_FAIL"

export const USER_DETAILS_REQUEST = "USER_DETAILS_REQUEST"
export const USER_DETAILS_SUCCESS = "USER_DETAILS_SUCCESS"
export const USER_DETAILS_FAIL = "USER_DETAILS_FAIL"


export const UPDATE_USER_PROFILE_REQUEST = "UPDATE_USER_PROFILE_REQUEST"
export const UPDATE_USER_PROFILE_SUCCESS = "UPDATE_USER_PROFILE_SUCCESS"
export const UPDATE_USER_PROFILE_FAIL = "UPDATE_USER_PROFILE_FAIL"
export const UPDATE_USER_PROFILE_RESET = "UPDATE_USER_PROFILE_RESET"